module.exports = __webpack_public_path__ + "_st_/media/womanForm.9848ccdd.png";